<template>
  <div class="pg-header">
    <div class="pg-header-left">
      <h1 class="pg-h1"><slot></slot></h1>
      <p v-if="subtitle" class="pg-h1-sub">{{ subtitle }}</p>
    </div>
    <div v-if="$slots.action" class="pg-header-action">
      <slot name="action"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PageTitle',
  props: {
    subtitle: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped>
.pg-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1.75rem;
  padding-bottom: 1.1rem;
  border-bottom: 1px solid #f0f0f5;
}
.pg-header-left { flex: 1; min-width: 0; }
.pg-h1 {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  font-size: 26px;
  font-weight: 900;
  color: #1a1a2e;
  letter-spacing: -0.03em;
  line-height: 1.15;
  margin: 0;
}
.pg-h1-sub {
  font-size: 13px;
  color: #8a8a9a;
  margin: 4px 0 0 0;
  line-height: 1.45;
}
.pg-header-action {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  margin-left: 16px;
}
</style>



// WEBPACK FOOTER //
// PageTitle.vue?36373813